import { Watch } from 'react-loader-spinner';

const Spinner = () => (
    <Watch
        height="100"
        width="100"
        color="#eda94a"
        ariaLabel="hearts-loading"
        wrapperStyle={{
            position: 'absolute',
            flexDirection: 'column',
            width: '100%',
            alignItems: 'center',
            top: window.innerHeight / 2 - 50 + 'px'
        }}
        wrapperClass="content"
        visible={true}
    />
);

export default Spinner;